var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('h1',[_vm._v("This is an our-mission-and-our-values page")]),_c('enfooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }